'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dialogClose = require('./dialog-close.html');

var _dialogClose2 = _interopRequireDefault(_dialogClose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _dialogClose2.default,
  controller: function () {
    function DialogCloseComponent($mdDialog) {
      'ngInject';

      _classCallCheck(this, DialogCloseComponent);

      Object.assign(this, { $mdDialog: $mdDialog });
    }

    _createClass(DialogCloseComponent, [{
      key: 'close',
      value: function close() {
        this.$mdDialog.hide();
      }
    }]);

    return DialogCloseComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/dialog-close/dialog-close.component.js